export interface ImageBlock {
  condition: string;
  images: string[];
}

export const imageBlocks: ImageBlock[] = [
  {
    condition: 'TABA',
    images: ['assets/img/UNCK-FORCE-N.jpg', 'assets/img/tabaBis.jpg'],
  },
  {
    condition: 'RECRUTEL',
    images: ['assets/img/UNCK-FORCE-N.jpg', 'assets/img/Activelles.jpg'],
  },
  {
    condition: 'ANPEJ',
    images: ['assets/img/UNCK-FORCE-N.jpg', 'assets/img/ANPEJ.jpeg'],
  },
  {
    condition: 'ADEPME',
    images: ['assets/img/UNCK-FORCE-N.jpg', 'assets/img/ADEPME.jpeg'],
  },
  {
    condition: 'DER',
    images: ['assets/img/UNCK-FORCE-N.jpg', 'assets/img/DER.jpg'],
  },
  {
    condition: 'MFP',
    images: ['assets/img/UNCK-FORCE-N.jpg', 'assets/img/MFPbis.jpg'], //
  },
  {
    condition: 'DE',
    images: ['assets/img/UNCK-FORCE-N.jpg', 'assets/img/MTERI.png'], //
  },
  {
    condition: 'MA',
    images: ['assets/img/UNCK-FORCE-N.jpg', 'assets/img/MA.jpg'], //
  },
  {
    condition: 'VOLONTAIRE',
    images: ['assets/img/volontaire_merged.png'], //
  },
  {
    condition: 'AVOC',
    images: ['assets/img/UNCK-FORCE-N.jpg'], //
  },
  {
    condition: 'SEPHIS',
    images: ['assets/img/UNCK-FORCE-N.jpg', 'assets/img/sephis.jpeg'],
  },
  {
    condition: 'DAC',
    images: ['assets/img/UNCK-FORCE-N.jpg', 'assets/img/DAC.jpg'],
  },
  {
    condition: 'ADPME',
    images: ['assets/img/FN-LOGO.png', 'assets/img/logoadpme_a_a.png'],
  },
  {
    condition: 'ASP',
    images: ['assets/img/FN-LOGO.png', 'assets/img/ASP.png'],
  },
  {
    condition: 'BATONGA',
    images: ['assets/img/BATONGA.jpeg'],
  },
  {
    condition: 'BE',
    images: ['assets/img/BE.jpeg'],
  },
  {
    condition: 'BLOLAB',
    images: ['assets/img/BLOLAB.jpeg'],
  },
  {
    condition: 'EMN',
    images: ['assets/img/EMN.jpeg'],
  },
];
